<template>
  <div class="content-wrapper">
    <b-row>
      <b-col md="12">
        <h3 class="pb-2" style="display: inline-block;padding-right: 5px;">{{user.firstName}} {{user.lastName}}</h3>
        <label style="text-align: center; " :class="user.status === 'Active' ? ' badge badge-success' : 'badge badge-danger'">{{ $t(user.status) }}</label>
      </b-col>
    </b-row>
    <div class="col-md-8 float-left">
      <b-card no-body class="col-md-12 no-padding float-left mr-2" :header="$t('User Information')" header-bg-variant="light" header-text-variant="white">
        <form ref="form" class="m-3">
          <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 100px;">
            <b-spinner
              variant="secondary"
            ></b-spinner>
          </div>
          <b-form-group style="width: 50%;float:left;" id="input-group-2" :label="$t('First Name')" label-for="input-2">
            <b-form-input
              id="input-2"
              v-model="form.firstName"
              required
              :placeholder="$t('First Name')"
              :state="$v.form.firstName.$dirty ? !$v.form.firstName.$error : null"
            ></b-form-input>
            <b-form-invalid-feedback id="input-1-live-feedback">
              {{$t('This is a required field')}}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group style="width: 50%;float:left;padding-left: 5px" id="input-group-6" :label="$t('Last Name')" label-for="input-2">
            <b-form-input
              id="input-6"
              v-model="form.lastName"
              required
              :placeholder="$t('Last Name')"
              :state="$v.form.lastName.$dirty ? !$v.form.lastName.$error : null"
            ></b-form-input>
            <b-form-invalid-feedback id="input-1-live-feedback">
              This is a required field.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            id="input-group-1"
            :label="user.hasOwnProperty('email') && user.email.includes('@yescheflabel.com') ? $t('Username') : $t('Email')"
            label-for="input-10"
          >
            <b-form-input
              disabled="disabled"
              id="input-10"
              autocomplete="off"
              v-model="user.emailUsername"
            ></b-form-input>
          </b-form-group>

          <!--<b-form-group-->
          <!--v-show="$route.name !== 'User'"-->
          <!--id="input-group-1"-->
          <!--label="Password:"-->
          <!--label-for="input-1"-->
          <!--description="Select a password for the user."-->
          <!--&gt;-->
          <!--<b-form-input-->
          <!--autocomplete="off"-->
          <!--id="input-1"-->
          <!--v-model="user.password"-->
          <!--type="password"-->
          <!--required-->
          <!--placeholder="Enter Password"-->
          <!--:state="$v.user.password.$dirty ? !$v.user.password.$error : null"-->
          <!--&gt;</b-form-input>-->
          <!--<b-form-invalid-feedback id="input-1-live-feedback">-->
          <!--Password length must be more than 6 digits-->
          <!--</b-form-invalid-feedback>-->
          <!--</b-form-group>-->

          <b-form-group style="width: 50%;float:left;" id="input-group-4" :label="$t('Role')" label-for="input-45">
            <b-form-select
              id="input-4"
              size="sm"
              disabled="disabled"
              v-model="user.role"
              :options="roles"
              required
            ></b-form-select>
          </b-form-group>
          <!--:disabled="$store.state.user.data.role === 'Manager'"-->
          <b-form-group style="width: 50%;float:left;padding-left: 5px" id="input-group-4" :label="$t('Status')" label-for="input-4">
            <b-form-select
              id="input-4"
              size="sm"
              v-model="form.status"
              :options="statuses"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group style="width: 50%;" id="input-group-4" :label="$t('Health Certificate Expiry Date')" label-for="input-4">
            <b-form-input
              id="name-input"
              type="date"
              v-model="form.healthCertExpDate"
            ></b-form-input>
          </b-form-group>
          <div class="form-group">
            <div style="display: inline-block;margin-bottom: 10px;margin-top: 10px;">
              <i class="fa fa-mobile" style="font-size: 20px;padding: 5px;padding-right: 8px;"></i><label class="pt-2">{{$t('Device')}}: {{user.deviceName? user.deviceName: $t('Empty')}}</label> <b-button size="sm" v-show="user.deviceName != null" @click="removeDevice()" variant="outline-danger" >{{$t('Unlink Device from User')}}</b-button> <br>
            </div>
            <div style="display: block;margin-bottom: 10px;margin-top: 10px;">
              <i class="fa fa-id-badge" style="font-size: 16px;padding: 5px;"></i><label class="pt-2">{{$t('License')}}: {{license.id ? license.expiryDate : $t('Empty')}} </label> <b-button size="sm" v-show="license.id != null" @click="removeLicense()" variant="outline-danger" >{{$t('Remove License')}}</b-button> <br>
            </div>
            <br>
            <label class="pt-2">{{$t('Created At')}}: {{user.createdAt}}</label>
          </div>
          <div class="text-right">
            <b-button @click="updateUser" variant="light" class="text-white">{{$t('Submit')}}</b-button>
          </div>
        </form>
      </b-card>
      <b-card v-show="['System Admin', 'Administrator', 'Manager'].includes($store.state.user.data.role) && user.role !== 'System Admin'" no-body class="col-md-12 float-left no-padding mb-3 mt-3" :header="$t('User Label Types')" header-bg-variant="light" header-text-variant="white">

        <b-row class="m-3">
          <b-col md="5">
            <h5>{{$t('Company Label Types')}}</h5>
            <b-list-group class="selected-label-types" v-if="companyLabelTypes.length > 0">
              <b-list-group-item v-for="type in companyLabelTypes" @click="addLabel(type.value)" v-bind:key="type.value" button>{{type.label}}</b-list-group-item>
            </b-list-group>
            <span class="font-italic text-center" v-else>Empty List</span>
          </b-col>
          <b-col md="2" class="text-center pt-5">
            <b-btn variant="light" class="text-white" @click="addAll"><i style="font-size: 20px;" class="fa fa-angle-double-right"></i></b-btn>
            <i class="fa fa-arrows-h pt-3" style="font-size: 30px;display: block;"></i>
            <b-btn class="mt-3" @click="removeAll"><i style="font-size: 20px;" class="fa fa-angle-double-left"></i></b-btn>

          </b-col>
          <b-col md="5">
            <h5>{{$t('User Label Types')}}</h5>
            <b-list-group class="available-label-types" v-if="labelTypes.length > 0">
              <b-list-group-item v-for="type in labelTypes" @click="removeLabel(type.value)" v-bind:key="type.value"  button>{{type.label}}</b-list-group-item>
            </b-list-group>
            <span class="font-italic text-center" v-else>Zero selected types</span>

          </b-col>
        </b-row>
        <b-row class="pt-2 mr-3 float-right" style=" display:block;">
          <b-btn style="float:right;color:white;margin-bottom: 20px" variant="light" @click="saveSettings">{{$t('Save')}}</b-btn>
        </b-row>
      </b-card>

    </div>
    <div class="col-md-3 float-left">
      <b-card v-show="$store.state.user.data.role === 'System Admin'" no-body class="col-md-12 float-left no-padding mb-3" :header="$t('Company')" header-bg-variant="light" header-text-variant="white">
        <b-list-group>
          <b-list-group-item :to="'/companies/'+user.companyId"><div class="text-left small text-black-50">{{company.name}}</div></b-list-group-item>
        </b-list-group>
      </b-card>
      <b-card v-show="['System Admin', 'Administrator'].includes($store.state.user.data.role)" no-body class="col-md-12 float-left no-padding" :header="$t('Categories')" header-bg-variant="light" header-text-variant="white">
        <b-list-group>
          <template v-for="category in userCategories">
            <b-list-group-item v-if="['System Admin'].includes($store.state.user.data.role)" v-bind:key="category" :to="'/companies/'+user.companyId+'/category/'+category"><p>{{category}}</p></b-list-group-item>
            <b-list-group-item v-else v-bind:key="category" :to="'/company/'+category"><p>{{category}}</p></b-list-group-item>

          </template>
        </b-list-group>
      </b-card>
      <b-card v-show="['System Admin', 'Administrator'].includes($store.state.user.data.role)" no-body class="col-md-12 float-left no-padding mt-3" :header="$t('Groups')" header-bg-variant="light" header-text-variant="white">
        <b-list-group>
          <template v-for="group in user.groups">
            <b-list-group-item  v-if="['System Admin'].includes($store.state.user.data.role)" v-bind:key="group.id" :to="'/companies/'+user.companyId+'/group/'+group.id"><div class="text-left small text-black-50">{{group.category}}</div><p>{{group.name}}</p></b-list-group-item>
            <b-list-group-item  v-else v-bind:key="group.id" :to="'/group/'+group.id"><div class="text-left small text-black-50">{{group.category}}</div><p>{{group.name}}</p></b-list-group-item>
          </template>
        </b-list-group>
      </b-card>

    </div>

  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import moment from 'moment'
export default {
  name: 'LicensedUserForm',
  data () {
    return {
      userCategories: [],
      companyLabelTypes: [],
      labelTypes: [],
      company: {},
      license: {},
      roles: [{ text: this.$t('Single User'), value: null }, { text: this.$t('System Admin'), value: 'System Admin' }, { text: this.$t('Administrator'), value: 'Administrator' }, { text: this.$t('Manager'), value: 'Manager' }, { text: this.$t('Supervisor'), value: 'Supervisor' }],

      loading: false,
      user: {},
      form: {},
      // roles: [{ text: 'Select Role', value: null }, 'System Admin', 'Administrator'],
      statuses: [{text: this.$t('Active'), value: 'Active'}, {text: this.$t('Inactive'), value: 'Inactive'}],

      show: true
    }
  },
  validations: {
    form: {
      lastName: {
        required,
        minLength: minLength(3)
      },
      firstName: {
        required,
        minLength: minLength(3)
      }
    }
  },
  mounted () {
    // console.log(this.$route.params.tabIndex)
    if (this.$route.params.tabIndex) {
      this.$store.state.tabIndex = this.$route.params.tabIndex
    }

    if (this.$route.params.id) {
      // this.user = this.$store.state.users.find(m => m.id === this.$route.params.id)

      if (!this.user.id) {
        this.getUserData()
      }
    }
    this.fetchUserSettings()
  },
  methods: {
    saveSettings () {
      var self = this
      this.$bvModal.msgBoxConfirm(self.$t('You are about to update user Label Types.'),
        {
          title: self.$t('Are you sure?'),
          okVariant: 'light',
          okTitle: self.$t('Confirm'),
          centered: true
        })
        .then(value => {
          if (value) {
            self.loading = true
            var arrayLabelTypes = []

            this.labelTypes.forEach(type => {
              arrayLabelTypes.push(type.value)
            })

            // console.log(arrayLabelTypes)
            const saveSettings = this.$firebase.functions().httpsCallable('saveUserSettings')
            saveSettings({labelTypes: arrayLabelTypes, userId: this.user.id}).then(function (result) {
              // success or error handling
              if (result.data.errorInfo) {
                self.$swal({
                  title: self.$t('There was an error!'),
                  text: result.data.errorInfo.message,
                  type: 'error',
                  timer: 0,
                  showConfirmButton: true
                })
              } else {
                self.$swal({
                  title: self.$t('Changes Saved!'),
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                })
              }
              self.loading = false
            })
          }
        })
    },
    fetchUserSettings () {
      var self = this
      // console.log('fetchUserSettings', self.$route.params.id)
      this.$firebase.firestore().doc('users/' + self.$route.params.id + '/settings/preferences').get().then(function (doc) {
        var preferences = doc.data()
        // console.log('user', preferences)
        if (preferences != null && preferences.hasOwnProperty('labelTypes')) {
          preferences.labelTypes.forEach(type => {
            self.labelTypes.push({value: type, label: self.$t(type)})
          })
        }
        self.fetchCompanySettings()
      })
    },
    fetchCompanySettings () {
      var self = this
      console.log('fetchCompanySettings', self.user.id)
      this.$store.dispatch('fetchCompanyPreferences', self.user.companyId).then(preferences => {
        console.log('comp', preferences)
        preferences.labelTypes.forEach(type => {
          var index = self.labelTypes.findIndex(t => t.value === type)
          console.log(type, index)
          if (index !== -1) {
            // self.companyLabelTypes.splice(index, 1)
          } else {
            self.companyLabelTypes.push({value: type, label: self.$t(type)})
          }
        })
      })
    },
    addAll () {
      var self = this
      this.companyLabelTypes.forEach((type, index) => {
        self.labelTypes.push(type)
      })
      self.companyLabelTypes.splice(0, self.companyLabelTypes.length)
    },
    removeAll () {
      var self = this
      this.labelTypes.forEach((type, index) => {
        self.companyLabelTypes.push(type)
      })
      self.labelTypes.splice(0, self.labelTypes.length)
    },
    addLabel (type) {
      var index = this.companyLabelTypes.findIndex(t => t.value === type)
      this.companyLabelTypes.splice(index, 1)
      this.labelTypes.push({value: type, label: this.$t(type)})
    },
    removeLabel (type) {
      var index = this.labelTypes.findIndex(t => t.value === type)
      this.labelTypes.splice(index, 1)
      this.companyLabelTypes.push({value: type, label: this.$t(type)})
    },
    async getUserData () {
      var self = this
      this.$firebase.firestore().doc('users/' + self.$route.params.id).get()
        .then(await async function (doc) {
          self.user = doc.data()
          self.user.id = doc.id
          if (self.user.createdAt != null) {
            self.user.createdAt = moment(String(self.user.createdAt.toDate())).format('DD/MM/YYYY kk:mm')
          }
          self.user.emailUsername = self.user.email.replace('@yescheflabel.com', '')
          self.form = JSON.parse(JSON.stringify(self.user))
          if (self.user.groups && self.user.groups.length > 0) {
            var groupIds = []
            let secGroupIds = []
            if (self.user.groups.length > 10) {
              groupIds = JSON.parse(JSON.stringify(self.user.groups.slice(0, 10)))
              secGroupIds = JSON.parse(JSON.stringify(self.user.groups.slice(-(self.user.groups.length - 10))))
            } else {
              groupIds = self.user.groups
            }

            self.$firebase.firestore().collection('companies').doc(self.user.companyId).collection('groups').where(self.$firebase.firestore.FieldPath.documentId(), 'in', groupIds).get()
              .then(await function (docs) {
                self.user.groups = []
                docs.forEach(function (doc) {
                  var group = doc.data()
                  group.id = doc.id
                  if (!self.userCategories.includes(group.category)) {
                    self.userCategories.push(group.category)
                  }
                  self.user.groups.push(group)
                })
                self.user.groups.sort((a, b) => (a.name > b.name) ? 1 : -1)
              })
            if (self.user.groups.length > 10) {
              self.$firebase.firestore().collection('companies').doc(self.user.companyId).collection('groups').where(self.$firebase.firestore.FieldPath.documentId(), 'in', secGroupIds).get()
                .then(await function (docs) {
                  // self.user.groups = []
                  docs.forEach(function (doc) {
                    var group = doc.data()
                    group.id = doc.id
                    if (!self.userCategories.includes(group.category)) {
                      self.userCategories.push(group.category)
                    }
                    self.user.groups.push(group)
                    // console.log('group', group)
                  })
                  self.user.groups.sort((a, b) => (a.name > b.name) ? 1 : -1)
                })
            }
          }
          if (self.user.companyId) {
            self.$firebase.firestore().collection('companies').doc(self.user.companyId).get()
              .then(await function (doc) {
                self.company = doc.data()
              })
            // get user license
            self.$firebase.firestore().collection('companies').doc(self.user.companyId).collection('licenses').where('userId', '==', self.user.id).get()
              .then(await function (licenseDoc) {
                licenseDoc.forEach(function (doc) {
                  self.license = doc.data()
                  self.license.id = doc.id
                  self.license.expiryDate = moment(String(doc.data().expiryDate.toDate())).format('DD/MM/YYYY')
                })
              })
          }
        })
    },
    // onSubmit (evt) {
    //   evt.preventDefault()
    //   let self = this
    //
    //   if (this.$route.name === 'User') {
    //     self.loading = true
    //     this.updateUser()
    //   } else {
    //     this.$v.user.$touch()
    //     if (this.$v.user.$anyError) {
    //       return
    //     }
    //     self.loading = true
    //     const createUser = this.$firebase.functions().httpsCallable('createUser')
    //     createUser(this.user).then(function (result) {
    //       // success or error handling
    //       if (result.data.errorInfo) {
    //         self.$swal({
    //           title: self.$t('There was an error!'),
    //           text: result.data.errorInfo.message,
    //           type: 'error',
    //           timer: 0,
    //           showConfirmButton: true
    //         })
    //       } else {
    //         self.$store.dispatch('fetchUsers')
    //         self.$swal({
    //           title: self.$t('System Admin Created!'),
    //           text: self.$t('Activated admins are ready to use the panel!'),
    //           type: 'success',
    //           timer: 3000,
    //           showConfirmButton: false
    //         }).then(function (result) {
    //           self.$router.push({name: 'Admins'})
    //         })
    //       }
    //       self.loading = false
    //     })
    //   }
    //   // create User and Authenticate user
    // },
    removeDevice () {
      var self = this
      self.loading = true
      const updateUserDevice = this.$firebase.functions().httpsCallable('updateUserDevice')
      updateUserDevice({id: self.user.id, deviceId: null, deviceName: null}).then(function (result) {
        if (result.data) {
          self.$swal({
            title: self.$t('Device Removed!'),
            type: 'success',
            timer: 1500,
            showConfirmButton: false
          }).then(function (result) {
            self.$store.dispatch('syncUser', self.user.id)
            self.user.deviceId = null
            self.user.deviceName = null
            self.loading = false
          })
        }
      })
    },
    removeLicense () {
      var self = this
      self.loading = true
      const unlinkLicense = this.$firebase.functions().httpsCallable('unlinkLicense')
      unlinkLicense({id: self.user.id, companyId: self.user.companyId}).then(function (result) {
        if (result.data) {
          self.$swal({
            title: self.$t('License Unlinked!'),
            type: 'success',
            timer: 1500,
            showConfirmButton: false
          }).then(function (result) {
            self.license.id = null
            self.license.expiryDate = null
            self.loading = false
          })
        }
      })
    },
    updateUser (e) {
      e.preventDefault()
      var self = this
      self.loading = true
      const updateUser = this.$firebase.functions().httpsCallable('updateUser')
      updateUser({id: this.user.id, firstName: this.form.firstName, lastName: this.form.lastName, status: this.form.status, healthCertExpDate: this.form.healthCertExpDate}).then(function (result) {
        // success or error handling
        // console.log(result)
        if (result.data) {
          self.$swal({
            title: self.$t('User Updated!'),
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          }).then(function (result) {
            self.loading = false
            self.getUserData()
          })
        }
      })
    },
    // createUser (companyId) {
    //   let self = this
    //   this.$firebase.auth.createUserWithEmailAndPassword(self.user.email, self.user.password).then(function (authUser) {
    //     self.firestore.collection('users').doc(authUser.user.uid).set(self.user)
    //       .then(function (docRef) {
    //         console.log('Document written: ', docRef)
    //       })
    //       .catch(function (error) {
    //         console.error('Error adding document: ', error)
    //       })
    //   }).catch(function (error) {
    //     // Handle Errors here.
    //     var errorCode = error.code
    //     var errorMessage = error.message
    //     console.log(errorCode, errorMessage)
    //     // ...
    //   })
    // },
    resetUserDetails () {
      // Reset our user values
      var userJson = JSON.parse(JSON.stringify(this.user))
      // console.log(userJson.firstName)
      this.form.firstName = userJson.firstName
      this.form.lastName = userJson.lastName
      this.form.status = userJson.status
    },
    resetModal () {
      this.newCategory.name = ''
      this.$v.$reset()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/User.vue